import { Box, CircularProgress } from '@mui/material';
import { Navigate, Outlet } from 'react-router';
import { usePermissions } from '../../hooks/use-permissions';
import { isGuardQuerySettling } from './guard-query-state';

interface DocGenerationBetaGuardProps {
  redirectTo?: string;
}

/**
 * Route guard for the doc-generation BETA feature. Checks BOTH the per-user
 * beta flag AND the DOCUMENT_GENERATION permission — this avoids a visible
 * double-redirect flash that occurs when only the beta flag is checked here
 * and the permission check fires separately in MainLayout's route guard.
 */
export function DocGenerationBetaGuard({ redirectTo = '/documents' }: DocGenerationBetaGuardProps) {
  const { docGenerationBetaEnabled, hasPermission, isPending, fetchStatus } = usePermissions();
  if (isGuardQuerySettling({ isPending, fetchStatus })) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '60vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  if (!docGenerationBetaEnabled || !hasPermission('DOCUMENT_GENERATION')) {
    return <Navigate to={redirectTo} replace />;
  }
  return <Outlet />;
}
